module.exports = __webpack_public_path__ + "files/5187933654fb3c62ce673bdcf523f922.png";